import React from "react";
import {Button, Descriptions, Space} from "antd";
import moment from "moment";

const RiderLists = (props) => {

  const rawItems =
    props.orderData &&
    props.orderData[0] &&
    props.orderData[0].order_details &&
    props.orderData[0].order_details.order_items
      ? props.orderData[0].order_details.order_items
      : [];

    const filteredItems = [];

    rawItems.forEach(item => {
      const itemNotShipped = parseInt(item.item_not_shipped);

      // Include the main order item if not shipped
      if (!isNaN(itemNotShipped) && itemNotShipped > 0) {
        filteredItems.push(item);
      }

      // If it's a bundle, check each bundle item
      if (Array.isArray(item.bundle_details)) {
        item.bundle_details.forEach(bundleItem => {
          const bundleNotShipped = parseInt(bundleItem.item_not_shipped);
          if (!isNaN(bundleNotShipped) && bundleNotShipped > 0) {
            filteredItems.push(bundleItem);
          }
        });
      }
    });

  return props.orderData ? (
    <Descriptions style={{ marginBottom: "35px" }} className="listLabelBold">
      {props?.orderData[0]?.parent_order_id && <Descriptions.Item label="K2 Replacement Order ID" span={3}>
        {props?.orderData[0]?.parent_order_id || "-"}
      </Descriptions.Item>}
      <Descriptions.Item label="Rider name" span={3}>
        {props?.orderData[0]?.rider?.fullName ? <a onClick={props.showOrderRiderModal}>{props?.orderData[0]?.rider?.fullName}</a> : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Rider ID" span={3}>
        {props?.orderData[0]?.rider?.display_id ? <a onClick={props.showOrderRiderModal}>{props?.orderData[0]?.rider?.display_id}</a> : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Rider Batch" span={3}>
        {props?.orderData[0]?.rider?.batch?.batchLevel ? <a onClick={props.showOrderRiderModal}>{props?.orderData[0]?.rider?.batch?.batchLevel}</a> : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Tracking link" span={3}>N\A</Descriptions.Item>
      {/* <Descriptions.Item label="KM Order ID" span={3}>N/A</Descriptions.Item> */}
      <Descriptions.Item label="WMS Order ID" span={3}>N\A</Descriptions.Item>
      <Descriptions.Item label="Created by" span={3}>
        {props?.orderData?.[0]?.user?.name || "system"}
      </Descriptions.Item>
      <Descriptions.Item label="Order Packed Time" span={3}>
        <Space>
          {props?.orderData[0]?.order_details?.invoice?.shipped_time ? moment(props?.orderData[0]?.order_details?.invoice?.shipped_time).subtract(5, "hours").format("DD MMMM, yyyy, h:mm A") : "-"}
          {/* {filteredItems.length > 0 && props.orderData?.[0]?.order_details?.invoice?.shipped_time ? (
            <Button onClick={props.showOrderItemNotShipped}>Items Not Shipped</Button>
          ) : null} */}
          {props?.orderData[0]?.order_details?.invoice?.shipped_time && (
            <Button onClick={props.showInvoiceDetails}>Invoice</Button>
          )}
        </Space>
      </Descriptions.Item>
      {/* <Descriptions.Item label="Mart Code" span={3}></Descriptions.Item>
      <Descriptions.Item label="Mart" span={3}>
        {postDataOrderView ? postDataOrderView.fullName : "-"}
      </Descriptions.Item> */}
    </Descriptions>
  ):"loading"
};
export default RiderLists;
